import React from 'react'
import {
  AlignItems,
  Body2,
  Bold,
  Box,
  Display,
  Heading2,
  JustifyContent,
  Link,
  Space,
} from '@gousto-internal/citrus-react'
import { LandingPageButton, LargeImageWithText } from '../../../../components'
import {
  FoodBoxPageSections,
  simpleTrackRedirect,
  TargetUri,
  TrackingActions,
} from '../../../../types/tracking'
import { WHATS_INSIDE } from './config'
import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import InsideGoustoBoxDesktop from '../../../../sections/assets/insidegoustobox-desktop.webp'
import InsideGoustoBoxMobile from '../../../../sections/assets/insidegoustobox-mobile.webp'

export function WhatsInsideSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <LargeImageWithText
      altText={WHATS_INSIDE.altText}
      mobileSrc={InsideGoustoBoxMobile}
      desktopSrc={InsideGoustoBoxDesktop}
    >
      <Heading2>{WHATS_INSIDE.heading}</Heading2>
      <Space size={4} />

      <Body2 size={4}>{WHATS_INSIDE.intro}</Body2>
      <Space size={6} />

      <Body2 size={4}>
        <Bold>{WHATS_INSIDE.subheading}</Bold>
      </Body2>
      <Space size={4} />

      {WHATS_INSIDE.benefits.map((benefit, index) => (
        <React.Fragment key={benefit.title}>
          <Box display={Display.Flex} alignItems={AlignItems.FlexStart}>
            <Box
              style={{
                fontSize: '20px',
                marginRight: '8px',
                flexShrink: 0,
              }}
            >
              {benefit.icon}
            </Box>
            <Body2 size={4}>
              <Bold>{benefit.title}</Bold> {benefit.description}
            </Body2>
          </Box>
          {index < WHATS_INSIDE.benefits.length - 1 && <Space size={4} />}
        </React.Fragment>
      ))}

      <Space size={6} />
      <Body2 size={4}>{WHATS_INSIDE.footer}</Body2>

      <Space size={4} />
      <Body2 size={4}>
        Interested in where our food comes from? Read up on the{' '}
        <Link
          href={TargetUri.SUPPLIERS}
          onClick={() =>
            simpleTrackRedirect(
              TrackingActions.SUPPLIERS,
              FoodBoxPageSections.WHATS_INSIDE_SECTION,
              TargetUri.SUPPLIERS,
            )
          }
        >
          suppliers
        </Link>{' '}
        you&apos;ll find in your Gousto box.
      </Body2>

      <Space size={6} />
      <Box
        display={Display.Flex}
        justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
      >
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={FoodBoxPageSections.WHATS_INSIDE_SECTION}
          target={TargetUri.SIGNUP}
          action={TrackingActions.CLICK_GET_STARTED}
        >
          {WHATS_INSIDE.ctaText}
        </LandingPageButton>
      </Box>
    </LargeImageWithText>
  )
}
